import { useMemo, useState } from "react";
import {
  // Box,
  Heading,
  VStack,
  Image,
  Text,
  Stack,
  HStack,
  CircularProgress,
  // Box,
  //   useDisclosure,
  // useToast,
  // Alert,
  // AlertIcon,
} from "@chakra-ui/react";

// import { useHistory } from "react-router-dom";

// import Button from "components/Button/Button";
import PhysicalCard from "components/Card/PhysicalCard";
import EmptyCards from "assets/png/empty-cards.png";
// import { ReactComponent as AddCircleIcon } from "assets/svg/add-circle.svg";
import {
  useGetPreorderStatusQuery,
  // useUnfreezeUserCardMutation,
} from "services/cardsApi";
import Select from "components/Select/Select";
import { capitalize } from "lodash";

// import toLower from "lodash/toLower";

const EmptyState = ({ isEligible, cards }) => {
  // const history = useHistory();
  return (
    <VStack my="60px">
      <Image boxSize="180px" objectFit="contain" src={EmptyCards} />
      <Heading as="h4" fontSize="lg" color="#14142B" textAlign="center">
        Pre-order Bitmama
        <br />
        Physical Card
      </Heading>
      <Text fontSize="sm" color="#14142B" mt="20px !important">
        Note: First come, first serve
      </Text>

      {/* <Button
        disabled={!isEligible}
        minW="300px"
        minH="64px"
        pos="relative"
        // top="100px"
        mt="80px !important"
        onClick={() => history.push("/dashboard/cards/preorder", { cards })}
      >
        Pre-Order Card
      </Button> */}
    </VStack>
  );
};

const UserCards = ({ isEligible, cards }) => {
  return (
    <Stack>
      {/* <HStack justifyContent="flex-end">
        <Button
          disabled={!isEligible}
          variant="ghost"
          bg="transparent"
          size="sm"
          color="#03A438"
          onClick={() => history.push("/dashboard/cards/request", { cards })}
        >
          <HStack>
            <Box as={AddCircleIcon} />
            <Text>Request Card</Text>
          </HStack>
        </Button>
      </HStack> */}

      <HStack
        flexWrap="wrap"
        gridGap="20px"
        mt="32px !important"
        justifyContent="flex-start"
        alignItems="flex-start"
        w="100%"
      >
        {cards?.map((card, i) => (
          <PhysicalCard
            key={`physical-card-${i}`}
            name={`${card?.cardDetails?.firstName} ${card?.cardDetails?.lastName}`}
            colorScheme="black"
            hasMessage={card?.status !== "issued"}
            isDeclined={card?.status === "declined"}
            status={card?.status}
          />
        ))}
      </HStack>
    </Stack>
  );
};

export default function PhysicalCards({
  // cards,
  isEligible,
  // isFetching,
  // isLoading,
}) {
  // const history = useHistory();

  const { data, isLoading, isFetching } = useGetPreorderStatusQuery();

  const [filter, setFilter] = useState("all");

  const cards = useMemo(() => data?.data?.data, [data]);

  const filteredCards = useMemo(
    () =>
      cards?.filter((card) =>
        filter === "all" ? card.status : card.status === filter
      ),
    [cards, filter]
  );

  const nonDeclined = useMemo(
    () => cards?.filter((card) => card?.status !== "declined"),
    [cards]
  );

  console.log("PHYSICAL CARDs", cards, nonDeclined);

  return (
    <>
      <HStack justifyContent="space-between">
        <Select value={filter} onChange={(e) => setFilter(e.target.value)}>
          {[
            "all",
            "declined",
            "cancelled",
            "pending",
            "approved",
            "issued",
          ].map((value) => (
            <option value={value} key={`status-${value}`}>
              {capitalize(value)}
            </option>
          ))}
        </Select>

        {/* {nonDeclined?.length === 0 && (
          <Button
            disabled={!isEligible}
            variant="ghost"
            bg="transparent"
            size="sm"
            color="#03A438"
            onClick={() => history.push("/dashboard/cards/preorder", { cards })}
          >
            <HStack>
              <Box as={AddCircleIcon} />
              <Text>Request Card</Text>
            </HStack>
          </Button>
        )} */}
      </HStack>

      {cards?.length === 0 && (
        <EmptyState isEligible={isEligible} cards={cards} />
      )}

      {cards?.length > 0 && (
        <UserCards
          isEligible={isEligible}
          isLoading={isFetching}
          cards={filteredCards}
        />
      )}

      <HStack w="100%" alignItems="center" justifyContent="center">
        {isLoading && (
          <CircularProgress
            disabled
            isIndeterminate
            color="#a7a7a7"
            size="32px"
          />
        )}
      </HStack>
    </>
  );
}
